<template>
  <article id="apitest">
    <!-- {{ data }}<br> -->
    ApiTest<br>
    <h2>{{ data.title }}</h2>
    {{ data.alt }}
    <br>
    <img :src="data.img">
  </article>
</template>

<script>

export default {
  name: 'ApiTest',

  data () {
    return {
      data: { test: 'https://xkcd.now.sh/' }
    }
  },

  created () {
    this.fetchData()
  },

  methods: {
    fetchData () {
      var xhr = new XMLHttpRequest()
      xhr.open('GET', 'https://xkcd.now.sh/', true)

      xhr.onload = e => {
        if (xhr.status === 200) {
          this.data = JSON.parse(xhr.response)
        }
      }

      xhr.send()
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../variables.scss';

#quad {
  background: url('../assets/img_pattern.webp') repeat, url('../assets/banner_quad.webp')  center center no-repeat;
  background-attachment: scroll, fixed;
  background-size: auto, cover;
}

</style>
